export default __webpack_public_path__ + "static/media/mirror_responsive.3df7d445.png";